import Permissions from '@/permissions'

const getMeta = (permissions, link) => {
  return {
    permissions,
    groups: 'project-type',
    breadcrumb: [
      {
        name_en: 'Settings',
        name_km: 'ការកំណត់'
      },
      {
        name_en: 'Project Type',
        name_km: 'ប្រភេទ'
      },
      link
    ]
  }
}

const projectType = Permissions.backend.setting.projectType

export const projectTypeRouters = {
  path: 'project-type',
  component: () => import('@/views/settings/projectType/Index'),
  redirect: 'project-type',
  meta: {
    permissions: [projectType.manage],
    groups: 'project-type'
  },
  children: [
    {
      path: '',
      name: 'list-project-type',
      component: () => import('@/views/settings/projectType/List'),
      meta: getMeta([projectType.list], {
        name_en: 'List',
        name_km: 'List'
      })
    },
    {
      path: 'create',
      name: 'create-project-type',
      component: () => import('@/views/settings/projectType/Create'),
      meta: getMeta([projectType.store], {
        name_en: 'Create',
        name_km: 'បង្កើត'
      })
    },
    {
      path: 'edit/:uuid',
      name: 'edit-project-type',
      component: () => import('@/views/settings/projectType/Edit'),
      meta: getMeta([projectType.edit], {
        name_en: 'Edit',
        name_km: 'កែសំរួល'
      })
    }
  ]
}
